<template>
  <UIcon
    name="light:spinner-third"
    class="animate-spin text-gray-500 dark:text-gray-400"
    data-element="spinner"
    aria-hidden="true"
  />
</template>
